/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Login_Resetpasswordplaceholder2Inputs */



/**

* @param {_Login_Resetpasswordplaceholder2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _login_resetpasswordplaceholder2 = /** @type {((inputs?: _Login_Resetpasswordplaceholder2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Login_Resetpasswordplaceholder2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Hinterlegte E-Mail oder Nutzername")
});
export { _login_resetpasswordplaceholder2 as "_login_resetPasswordPlaceholder" }